import { render, staticRenderFns } from "./addExpense.vue?vue&type=template&id=6dec7446&scoped=true"
import script from "./addExpense.vue?vue&type=script&lang=js"
export * from "./addExpense.vue?vue&type=script&lang=js"
import style0 from "./addExpense.vue?vue&type=style&index=0&id=6dec7446&prod&scoped=true&lang=css"
import style1 from "./addExpense.vue?vue&type=style&index=1&id=6dec7446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec7446",
  null
  
)

export default component.exports